/**
 * @flow
 * @relayHash 1fbb3c75f8e00808094c37b8100744d9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CustomerOriginUpdateInput = {|
  id: string,
  name: string,
|};
export type UpdateCustomerOriginMutationVariables = {|
  data: CustomerOriginUpdateInput
|};
export type UpdateCustomerOriginMutationResponse = {|
  +updateCustomerOrigin: {|
    +id: string
  |}
|};
export type UpdateCustomerOriginMutation = {|
  variables: UpdateCustomerOriginMutationVariables,
  response: UpdateCustomerOriginMutationResponse,
|};
*/


/*
mutation UpdateCustomerOriginMutation(
  $data: CustomerOriginUpdateInput!
) {
  updateCustomerOrigin(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "CustomerOriginUpdateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateCustomerOrigin",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "CustomerOriginModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateCustomerOriginMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateCustomerOriginMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateCustomerOriginMutation",
    "id": null,
    "text": "mutation UpdateCustomerOriginMutation(\n  $data: CustomerOriginUpdateInput!\n) {\n  updateCustomerOrigin(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '815282c20364d92f58bbce3466877545';
module.exports = node;
